import React from "react";
import logo from "../../assets/images/logo.gif";
import { motion } from "framer-motion";

export const Loader = () => {
  return (
    <div className="flex justify-center items-center w-screen h-screen">
      <motion.div
        animate={{ opacity: [0.2, 1, 0.2] }}
        transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        className="flex items-center justify-center"
      >
        <img src={logo} alt="Loading" className="w-20 h-20" />
      </motion.div>
    </div>
  );
};

export default Loader;
